@for (node of nodes(); track $index) {
  @switch (node.type) {
    @case ('text') {
      <ng-container>{{ node.text }}</ng-container>
    }
    @case ('linebreak') {
      <br>
    }
    @case ('link') {
      <a [href]="node.href" target="_blank" rel="noopener noreferrer">
        @if (node.image) {
          <img [src]="node.href" [alt]="node.href">
        } @else {
          <ng-container>{{ node.label }}</ng-container>
        }
      </a>
    }
  }
}
